// extracted by mini-css-extract-plugin
export default {"message":"Message_message__GR0sF","sucess":"Message_sucess__X8zdz","error":"Message_error__lj+4k"};